/**
 * Custom header – megamenu panel toggle + chevron for links that have a panel.
 */
(function () {
  const section = document.querySelector('.custom-header-section');
  if (!section) return;

  const panels = section.querySelectorAll('.custom-header-megamenu-panel');
  const nav = section.querySelector('.custom-header-primary-nav');
  if (!nav) return;

  // Titles that have a megamenu panel (from DOM; Liquid can't expose block type in parent section)
  const megamenuTitles = new Set(
    Array.from(panels).map((p) => (p.getAttribute('data-megamenu-title') || '').trim()).filter(Boolean)
  );

  const chevronSvg =
    '<svg class="tw:shrink-0 tw:inline-block tw:fill-current" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M7.59168 2.27373C7.64329 2.32532 7.68422 2.38657 7.71215 2.45399C7.74008 2.5214 7.75445 2.59365 7.75445 2.66662C7.75445 2.73959 7.74008 2.81184 7.71215 2.87926C7.68422 2.94667 7.64329 3.00792 7.59168 3.05951L4.39168 6.25951C4.28738 6.36351 4.14609 6.42191 3.99879 6.42191C3.8515 6.42191 3.71021 6.36351 3.6059 6.25951L0.405904 3.05951C0.301703 2.95531 0.243164 2.81398 0.243164 2.66662C0.243164 2.51926 0.301703 2.37793 0.405904 2.27373C0.510105 2.16953 0.651431 2.11099 0.798793 2.11099C0.946155 2.11099 1.08748 2.16953 1.19168 2.27373L3.99879 5.08084L6.8059 2.27373C6.85749 2.22213 6.91874 2.18119 6.98616 2.15327C7.05357 2.12534 7.12582 2.11096 7.19879 2.11096C7.27176 2.11096 7.34402 2.12534 7.41143 2.15327C7.47884 2.18119 7.54009 2.22213 7.59168 2.27373Z" fill="currentColor"/></svg>';

  section.querySelectorAll('a[data-megamenu-trigger]').forEach((link) => {
    const title = (link.getAttribute('data-megamenu-trigger') || '').trim();
    if (megamenuTitles.has(title)) {
      const wrap = document.createElement('span');
      wrap.className = 'custom-header-chevron-icon tw:inline-flex tw:transition-transform tw:duration-300 tw:ease-[ease]';
      wrap.innerHTML = chevronSvg;
      link.appendChild(wrap);
    }
  });

  function getTriggerLinks() {
    return section.querySelectorAll('a[data-megamenu-trigger]');
  }

  function setTriggerOpenState(openLink, isOpen) {
    getTriggerLinks().forEach((el) => el.classList.remove('custom-header-megamenu-open'));
    if (openLink && isOpen) openLink.classList.add('custom-header-megamenu-open');
  }

  function closeAllPanels() {
    panels.forEach((panel) => {
      panel.classList.add('tw:opacity-0', 'tw:invisible', 'tw:pointer-events-none');
      panel.setAttribute('aria-hidden', 'true');
    });
    setTriggerOpenState(null, false);
  }

  function openPanel(panel, triggerLink) {
    closeAllPanels();
    if (panel) {
      panel.classList.remove('tw:opacity-0', 'tw:invisible', 'tw:pointer-events-none');
      panel.setAttribute('aria-hidden', 'false');
      setTriggerOpenState(triggerLink, true);
    }
  }

  nav.addEventListener('click', (e) => {
    const link = e.target.closest('a[data-megamenu-trigger]');
    if (!link) return;

    e.preventDefault();
    const title = (link.getAttribute('data-megamenu-trigger') || link.textContent || '').trim();
    const panel = Array.from(panels).find(
      (p) => (p.getAttribute('data-megamenu-title') || '').trim() === title
    );

    if (panel) {
      const isOpen = !panel.classList.contains('tw:invisible');
      if (isOpen) closeAllPanels();
      else openPanel(panel, link);
    } else {
      window.location.href = link.href;
    }
  });

  document.addEventListener('click', (e) => {
    if (section.contains(e.target)) return;
    closeAllPanels();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllPanels();
  });
})();
